// = Libs =
import { FC } from 'react';
import clsx from 'clsx';

// = Styles =
import classes from './card.module.scss';

// = Types =
import { CardProps } from './card.types';

const Card: FC<CardProps> = (props) => {
  const { children, className = '' } = props;

  return (
    <div
      className={clsx(
        {
          [classes.card]: true,
        },
        className
      )}>
      {children}
    </div>
  );
};

export default Card;
